import { render, staticRenderFns } from "./SessionResultCard.vue?vue&type=template&id=0df6b6ca&scoped=true"
import script from "./SessionResultCard.vue?vue&type=script&lang=js"
export * from "./SessionResultCard.vue?vue&type=script&lang=js"
import style0 from "./SessionResultCard.vue?vue&type=style&index=0&id=0df6b6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6b6ca",
  null
  
)

export default component.exports